import '../styles/stepTwo.css'

import arcadeImg from '../assets/images/icon-arcade.svg'
import advancedImg from '../assets/images/icon-advanced.svg';
import proImg from '../assets/images/icon-pro.svg';

import { useContext, useState } from 'react';
import AppContext from '../context/formContext';


const StepTwo = () => {
    const { setForm } = useContext(AppContext);
    const [payPlan, setPayPlan] = useState('Monthly');
    const [active, setActive] = useState('Arcade');

    const changePayPlan = (e) => {
        if (e.target.checked) {
            setPayPlan('Yearly')
        }
        else{
            setPayPlan('Monthly')
        }
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        const values = e.target.elements['plan'];
        values.forEach((e) => {
            if (e.checked) {
                localStorage.setItem('plan',JSON.stringify({ 'plan': e.id, 'price': e.value, "range": payPlan }))
            }
        })
        setForm(3)
    }


    return ( 
        <div className="stepTwoCard">
            <section>
                <h1>Select Your Plan</h1>
                <p>You have the option of monthly or yearly billing.</p>
            </section>
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="radio">
                     <label htmlFor="Arcade" className={`options ${active === 'Arcade' ? 'active' : ''}`}>
                    <img src={arcadeImg} alt="arcade plan" />
                    <div className="data">
                        <h3>Arcade</h3>
                        <span>{payPlan === 'Monthly' ? '$9/mo' : '$90/yr'}</span>
                        <p className={payPlan === "Yearly" ? 'activeBonus' : ''}>2 months free</p>
                    </div>
                    <input type="radio" id="Arcade" name="plan" value={payPlan === 'Monthly' ? 9 : 90} required onChange={()=>setActive('Arcade')} defaultChecked={true}/>
                </label>

                <label htmlFor="Advanced"  className={`options ${active === 'Advance' ? 'active' : ''}`}>
                    <img src={advancedImg} alt="advanced plan" />
                    <div className="data">
                        <h3>Advanced</h3>
                        <span>{payPlan === 'Monthly' ? '$12/mo' : '$120/yr'}</span>
                        <p className={payPlan === "Yearly" ? 'activeBonus' : ''}>2 months free</p>
                    </div>
                    <input type="radio" id="Advanced" name="plan" onChange={() => setActive('Advance')} value={payPlan === 'Monthly' ? 12 : 120} required />
                </label>

                <label htmlFor="Pro"  className={`options ${active === 'Pro' ? 'active' : ''}`}>
                    <img src={proImg} alt="pro plan" />
                    <div className="data">
                        <h3>Pro</h3>
                        <span>{payPlan === 'Monthly' ? '$15/mo' : '$150/yr'}</span>
                        <p className={payPlan === "Yearly" ? 'activeBonus' : ''}>2 months free</p>
                    </div>
                    <input type="radio" id="Pro" name="plan" value={payPlan === 'Monthly' ? 15 : 150} onChange={()=>setActive('pro')}  required />
                </label>

               </div>
                <label htmlFor="planPay" className='planPay'>
                    <p className={payPlan === 'Monthly' ? 'activeType' : ''}>Monthly</p>
                    <div className='switch'>
                        <div className={`switchCursor ${payPlan === 'Yearly' ? 'switchActive' : ''}`}></div>
                    </div>
                    <input type="checkbox" id='planPay' onChange={(e)=>changePayPlan(e)} />
                    <p className={payPlan === 'Yearly' ? 'activeType' : ''}>Yearly</p>
                </label>
                 <button className='goBack' onClick={()=>setForm(1)}>Go Back</button>
                 <input className="nextBtn" type="submit" value="Next Step"></input>
            </form>
        </div>
     );
}
 
export default StepTwo;